<template>
  <HomePanel ref="target" title="医用设备考评">
    <template v-slot:right>
      <ShMore to="/video?firstCate=163" />
    </template>
    <div class="box">
      <Transition name="fade">
        <template v-if="sideImg.length">
          <RouterLink
            target="_blank"
            class="cover"
            :to="`${sideImg[3]?.bannerUrl}`"
          >
            <img v-lazy="sideImg[3]?.bannerImg" :alt="sideImg[3]?.bannerDesc" />
          </RouterLink>
        </template>
        <SideImgSkeleton v-else />
      </Transition>
      <LessonItem :goods="goods" />
    </div>
  </HomePanel>
</template>

<script>
import SideImgSkeleton from "./side-img-skeleton.vue";
import LessonItem from "./lesson-item.vue";
import HomePanel from "./home-panel.vue";
import ShMore from "@/components/library/sh-more.vue";
import { ref } from "vue";
import { useLazyData } from "@/hooks";
import { findSheBei } from "@/api/home";
export default {
  name: "HomeLesson",
  components: {
    HomePanel,
    ShMore,
    LessonItem,
    SideImgSkeleton,
  },
  props: {
    sideImg: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    //获取首页大型设备
    const target = ref(null);

    const { result } = useLazyData(target, () => findSheBei(163));
    return { goods: result, target };
  },
};
</script>

<style scoped lang="less">
.home-product {
  background: #fff;

  .sub {
    margin-bottom: 2px;
    a {
      padding: 2px 12px;
      font-size: 16px;
      border-radius: 4px;
      &:hover {
        background: @shColor;
        color: #fff;
      }
      &:last-child {
        margin-right: 80px;
      }
    }
  }
  .box {
    display: flex;
    .cover {
      width: 240px;
      height: 610px;
      //margin-right: 10px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
